import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
import { User, LogIn, LogOut } from 'react-feather';
import { ToastContainer, toast } from 'react-toastify';
import { FiDownload, FiLogIn, FiLogOut, FiUsers, FiUserCheck } from 'react-icons/fi';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MdQrCode } from 'react-icons/md';
import { AiOutlineClose } from "react-icons/ai";

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ClearButton = styled.button`
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: #2B3497;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #1f2b91;
  }
`;
const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color: #2B3497;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;

const AreaDropdown = styled.select`
  padding: 8px 12px;
  font-size: 14px;
  border: 1.5px solid #2B3497;
  border-radius: 8px;
  background-color: #ffffff;
  color: #2B3497;
  font-family: 'Segoe UI', Semibold;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #1f2b91;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    border-color: #1f2b91;
    box-shadow: 0px 0px 0px 3px rgba(43, 52, 151, 0.2);
  }

  option {
    background-color: #fff;
    color: #2B3497;
  }
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1;
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000;
`;

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 9px 10px;
  text-align: left;
  font-size: 14px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }
  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
  font-size: 13px;
`;

const Circle = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(#ffffff, #f6f6f6);
  border-radius: 50%;
  box-shadow: 0px 10px 10px #00000024;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProfileIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2b3497;
  font-size: 30px;
  font-weight: bold;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 6px;
  display: inline-flex;
  align-items: center;
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;

const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;

// Modal styles
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 999;
`;

const ModalContent = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
//   height: 185px;

height: ${({ modalType }) =>
        modalType === "Check-Out" ? "200px" : "auto"};
  min-height: ${({ modalType }) =>
        modalType === "Check-In" ? "280px" : "unset"};

`;


const InputField = styled.input`
  background-color: transparent;
  width: 100%;
  height: 40px;
  padding: 1px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;

  &.add-location {
    background-color: #293495;
  }

  &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }
`;

const ModalButton = styled(Button)`
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 12px;
  min-width: 80px;

  &.ok {
    background-color: #293495;
  }

  &.cancel {
    background-color: red;
  }
`;
const DropdownContainerTwoo = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const ExportIcono = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #293495;
`;

const OptionsPanelo = styled.div`
  position: absolute;
  top: 30px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 150px;
  z-index: 10;
`;

const OptionItemo = styled.div`
  padding: 10px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background-color: #f1f1f1;
  }
`;
const DropdownContainerQR = styled.div`
  position: relative;
  margin-left: 15px;
`;

const QRIcon = styled.div`
  cursor: pointer;
  color: #2b3497;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.1);
  }
`;

const QRPanel = styled.div`
  position: absolute;
  top: 35px;
  right: 0;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  min-width: 235px;
  z-index: 10;
`;

const QRItem = styled.div`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  color: #333;
  &:hover {
    background-color: #f0f4ff;
    color: #2b3497;
  }
`;

const PopupCh = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
   background: #fff;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 400px;
  height: 174px;
`;


const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
`;


const InputFieldN = styled.input`
  background-color: transparent;
  width: 80%;
  height: 40px;
  padding: 1px;
  font-size: 14px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 2px solid #2B3497;
  border-radius: 0;
  text-align: left;
  outline: none;

  &::placeholder {
    color: #000000;
  }

  /* Remove up and down arrows for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 5px;
`;

const Asterisk = styled.span`
  color: red;
`;

const FileUploadContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const CustomFileButton = styled.button`
  background-color: #293495;
  color: #ffffff;
  padding: 8px 16px;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1f2875;
  }
`;

const FileNameInput = styled.input`
  flex: 1;
  padding: 8px;
  border: none;
  border-bottom: 1px solid #2b3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  color: #000;

  &:focus {
    outline: none;
    border-bottom: 2px solid #2b3497;
  }
`;


const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1100;
`;

const PopupContent = styled.div`
  background: #fff;
  padding: 28px 24px;
  border-radius: 16px;
  box-shadow: 0px 12px 28px rgba(0, 0, 0, 0.25);
  width: 360px;
  text-align: center;
  animation: fadeIn 0.25s ease-out;

  @keyframes fadeIn {
    from {
      transform: scale(0.9);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const PopupTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
 font-family: 'Segoe UI', 'Semibold';
  color: #2B3497;`;

const PopupImage = styled.img`
  width: 110px;
  height: 110px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 16px;
  border: 3px solid #f0f0f0;
`;

// const PopupText = styled.p`
//   font-size: 15px;
//   margin: 6px 0;
//   color: #444;

//   span {
//     font-weight: 600;
//     color: #333;
//   }
// `;
const PopupRow = styled.div`
  display: flex; 
  justify-content: center; /* Center the row block */ 
  align-items: center; 
  margin: 6px 0; 
  font-size: 15px;
  gap: 8px;

`;

// const Label = styled.span`
//   font-weight: 600;
//   color: #2B3497;   /* Blue */
//   margin-right: 6px;
// `;
const Label = styled.span`
  font-weight: 500;
  font-size: 15px;
  color: #2B3497;   /* Blue */
  display: block;
  margin-bottom: 5px;
  text-align: left;
  gap:5px;
`;


const Value = styled.span`
  font-weight: 500;
  display: block;
  color: #000;      /* Black */
  font-size: 15px;
  line-height: 1.3;

`;


const PopupButtons = styled.div`
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

const PopupButtonYes = styled.button`
  flex: 1;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  background-color: #2B3397;
  color: #fff;
  text-align: center;
`;

const PopupButtonNo = styled.button`
  flex: 1;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  background: linear-gradient(135deg, #f44336, #e53935);
  color: #fff;
  transition: all 0.25s ease-in-out;
  text-align: center;

  &:hover {
    background: linear-gradient(135deg, #e53935, #c62828);
    transform: translateY(-2px);
  }
`;

const DropdownWrapper = styled.div`
  position: relative;
  width: 250px;
  right:10px;
`;

const SearchInputN = styled.input`
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1.5px solid #2B3497;
  border-radius: 8px;
  color: #2B3497;
  font-family: 'Segoe UI', Semibold;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  outline: none;

  &:focus {
    border-color: #1f2b91;
    box-shadow: 0px 0px 0px 3px rgba(43, 52, 151, 0.2);
  }
`;

const OptionsList = styled.ul`
  position: absolute;
  top: 110%;
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 1000;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.15);
`;

const OptionItem = styled.li`
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  color: #2B3497;
  font-family: 'Segoe UI', Semibold;

  &:hover {
    background: #f0f2ff;
  }
`;


const AreaCheckIn = () => {
    const [selectedArea, setSelectedArea] = useState(null);
    const [transportVendorFileName, setTransportVendorFileName] = useState("");
    const [transportVendorFileBase64, setTransportVendorFileBase64] = useState("");

    const dummyData = Array.from({ length: 23 }, (_, index) => ({
        photo: '',
        visitID: `V${100 + index}`,
        visitType: index % 2 === 0 ? 'Business' : 'Personal',
        visitorName: `Visitor ${index + 1}`,
        mobile: `90000000${index}`,
        nationality: index % 2 === 0 ? 'USA' : 'India',
        host: index % 2 === 0 ? 'Alice' : 'Bob',
        location: index % 2 === 0 ? 'location A' : 'location B',
        area: index % 2 === 0 ? 'Area A' : 'Area B',
        checkIn: '2025-07-10 10:00 AM',
        checkOut: '2025-07-10 12:00 PM',
    }));

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }

            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...base64,"
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };



    // const [currentPage, setCurrentPage] = useState(1);
    // const rowsPerPage = 10;
    // const totalPages = Math.ceil(dummyData.length / rowsPerPage);
    // const startIndex = (currentPage - 1) * rowsPerPage;
    // const currentData = dummyData.slice(startIndex, startIndex + rowsPerPage);

    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [selectedVisitor, setSelectedVisitor] = useState(null);
    const [enteredMobile, setEnteredMobile] = useState('');
    const [confirmationPopup, setConfirmationPopup] = useState({
        show: false,
        visitor: null,
        payload: null
    });

    const handleModalConfirm = async () => {


        const getMobileAfterHyphen = (mobile) => {
            // If mobile contains hyphen(s), return last segment
            if (mobile.includes('-')) {
                return mobile.split('-').pop().trim();
            }
            // If no hyphen, return as-is (assuming full number is entered)
            return mobile.trim();
        };

        const mobileFromTable = getMobileAfterHyphen(selectedVisitor.visitorMobile || '');
        const mobileEntered = enteredMobile.trim();

        if (mobileEntered == "") {
            toast.error('Please enter mobile number');
            return;
        }

        if (mobileFromTable !== mobileEntered) {
            toast.error('Mobile number mismatch!');
            return;
        }

        const isGroupMember = selectedVisitor?.isGroupMember;
        // const hasNdaFile = Boolean(transportVendorFileName);

        // if (!isGroupMember && !hasNdaFile) {
        //     toast.error("NDA Document file is mandatory");
        //     return;
        // }

        //  const ndaDocument = transportVendorFileBase64;
        // Common payload for both check-in and check-out
        const payload = {
            area: selectedArea?.name || "",
            checkedin: selectedVisitor.checkedin,
            inPremises: selectedVisitor.inPremises,
            checkedout: selectedVisitor.checkedout,
            crossed: selectedVisitor.crossed,
            expectedCount: selectedVisitor.expectedCount,
            udCount: selectedVisitor.udCount,
            source: selectedVisitor.source,
            visitorName: selectedVisitor.visitorName,
            checkInId: selectedVisitor.checkInId,
            visitorTypeDesc: selectedVisitor.visitorTypeDesc,
            checkInType: selectedVisitor.checkInType,
            hostName: selectedVisitor.hostName,
            gate: selectedVisitor.gate,
            checkInDateTime: selectedVisitor.checkInDateTime,
            passReturnedDateTime: "0001-01-01T00:00:00",
            serviceProviderAccess: "False",
            visitorMobile: selectedVisitor.visitorMobile,
            appointmentId: selectedVisitor.appointmentId,
            photo: selectedVisitor.photo || "",
            host: selectedVisitor.host,
            location: selectedVisitor.location,
            purpose: selectedVisitor.purpose,
            recurring: selectedVisitor.recurring,
            status: selectedVisitor.status,
            nationality: selectedVisitor.nationality,
            meetingTo: selectedVisitor.meetingTo,
            areaCheckInDateTime: selectedVisitor.areaCheckInDateTime,
            areaCheckOutDateTime: selectedVisitor.areaCheckOutDateTime,
            override: null,
            save: false,
            //     ndaDocument: ndaDocument,
            isGroupMember: isGroupMember
        };

        try {
            if (modalType === 'checkin') {
                const response = await axios.post('Dashboard/AreaCheckIn', payload);
                if (response.data?.statusCode === 1) {
                    toast.error(response.data?.message)
                    setSelectedVisitor(null); // if used

                } else if (response.data?.statusCode === 2) {
                    toast.error(response.data?.message)
                    setSelectedVisitor(null); // if used

                } else if (response.data?.statusCode === 0) {
                    // toast.success(response.data?.message);
                    // setSelectedVisitor(null); // if used
                    setConfirmationPopup({
                        show: true,
                        visitor: {
                            visitorName: response.data.visitorName || selectedVisitor.visitorName,
                            photo: response.data.visitorPhoto || selectedVisitor.photo,
                            area: response.data.area || selectedArea?.name,
                            isGroupMember: isGroupMember
                        },
                        payload
                    });
                    //console.log("Check-In Response:", response.data);
                }
            } else if (modalType === 'checkout') {
                try {
                    const response = await axios.put('Dashboard/AreaCheckOut', payload);

                    if (response.data === 'Visitor is not checked-in.') {
                        toast.warning('Visitor is not checked-in.');
                    } else {
                        toast.success('Visitor checked out successfully');
                    }
                } catch (error) {
                    console.error('Checkout error:', error);
                    toast.error('Something went wrong during checkout.');
                }
            }

            setShowModal(false);
            setEnteredMobile('');
            // Optionally refresh data here
            const fetchAreasList = async () => {
                const id = 0;
                try {
                    const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                    setVisitorData(response.data.details);
                } catch (error) {
                    console.error("Failed to fetch visitor data:", error);
                    setVisitorData([]);
                }
            };
            fetchAreasList()


        } catch (error) {
            console.error(`${modalType === 'checkin' ? 'Check-In' : 'Check-Out'} Error:`, error);
            toast.error(`${modalType === 'checkin' ? 'Check-In' : 'Check-Out'} failed. Please try again.`);
        } finally {
            // Cleanup ALWAYS runs
            setTransportVendorFileBase64("");
            setTransportVendorFileName('');
        }
    };

    const [isPanelOpenE, setIsPanelOpenE] = useState(false);

    const togglePanelE = () => {
        setIsPanelOpenE((prevState) => !prevState);
    };

    const handleExportOptionClick = (format) => {
        if (format === 'excel') {
            exportToExcel(); // Call the Excel export function
        } else if (format === 'pdf') {
            exportToPDF(); // Call the PDF export function
        }

        // Close the panel after making a selection
        setIsPanelOpenE(false);
    };
    const exportToExcel = () => {
        const exportData = filteredData.map((row) => ({
            'Visit ID (Appt ID)': row.appointmentId || '',
            'Visit Type': row.source || '',
            'Visitor Name': row.visitorName || '',
            'Visitor Type': row.visitorTypeDesc || '',
            'Visitor Mobile': row.visitorMobile || '',
            'Nationality': row.nationality || '',
            'Host': row.host || '',
            'Location': row.location || '',
            'Area': row.area || '',
            'Check-In (Area)': row.areaCheckInDateTime || '',
            'Check-Out (Area) ':
                (row.areaCheckOutDateTime === "0001-01-01T00:00:00" || row.areaCheckOutDateTime === null)
                    ? ''
                    : row.areaCheckOutDateTime || '',
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Area Check-In Report');

        worksheet['!cols'] = [
            { wpx: 120 }, // Visit ID
            { wpx: 100 }, // Visit Type
            { wpx: 150 }, // Visitor Name
            { wpx: 130 }, // Mobile
            { wpx: 100 }, // Nationality
            { wpx: 150 }, // Host
            { wpx: 150 }, // Location
            { wpx: 120 }, // Area
            { wpx: 160 }, // Check-In
            { wpx: 160 }, // Check-Out
        ];

        XLSX.writeFile(workbook, 'Area_CheckIn_Report.xlsx');
    };


    const exportToPDF = () => {
        const doc = new jsPDF('landscape');
        doc.text('Area Check-In Reports', 14, 16);
        doc.autoTable({
            head: [
                ['Photo', 'Visit ID (Appt ID)', 'Visit Type	', 'Visitor Name', 'Visitor Type', 'Visitor Mobile', 'Nationality', 'Host', 'Location', 'Area', 'Check-In (Area)', 'Check-Out (Area)']
            ],
            body: filteredData.map((row) => [
                '',
                row.appointmentId,
                row.source,
                row.visitorName,
                row.visitorTypeDesc,
                row.visitorMobile,
                row.nationality,
                row.host,
                row.location,
                row.area,
                row.areaCheckInDateTime,
                (row.areaCheckOutDateTime === "0001-01-01T00:00:00" || row.areaCheckOutDateTime === null)
                    ? ''
                    : row.areaCheckOutDateTime || '',
            ]),
            startY: 30,
            theme: 'grid',
            didDrawCell: (data) => {
                // Ensure we only process body cells, not header or footers
                if (data.section === 'body' && data.column.index === 0 && filteredData[data.row.index]?.photo) {
                    const img = `data:image/png;base64,${filteredData[data.row.index].photo}`;

                    // Get cell dimensions
                    const cellWidth = data.cell.width;
                    const cellHeight = data.cell.height;

                    // Define the image size (smaller to fit properly)
                    const imgSize = Math.min(cellWidth, cellHeight) - 2; // Padding of 2px on each side

                    // Center the image within the cell
                    const xOffset = data.cell.x + (cellWidth - imgSize) / 2;
                    const yOffset = data.cell.y + (cellHeight - imgSize) / 2;

                    doc.addImage(img, 'PNG', xOffset, yOffset, imgSize, imgSize);
                }
            },
        });
        doc.save('Area_Check-In_Report.pdf');
    };



    const [areas, setAreas] = useState([]);
    const [visitorData, setVisitorData] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);






    useEffect(() => {
        const fetchAreas = async () => {
            try {
                const response = await axios.get('Location/GetAllBuildings');
                const fetchedAreas = response.data || [];

                const allAreaOption = {
                    id: 0,
                    name: 'All Areas',
                    gate: '',
                };

                const formattedAreas = [allAreaOption, ...fetchedAreas];
                // console.log(formattedAreas, "formattedAreas");

                setAreas(formattedAreas);
                setSelectedArea(allAreaOption); // default selection
            } catch (error) {
                console.error('Error fetching areas:', error);
            }
        };
        const fetchAreasList = async () => {
            const id = 0;
            try {
                const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${id}`);
                setVisitorData(response.data.details);
            } catch (error) {
                console.error("Failed to fetch visitor data:", error);
                setVisitorData([]);
            }
        };


        fetchAreas();
        fetchAreasList()

    }, []);

    useEffect(() => {
        const filtered = visitorData.filter((item) => {
            return Object.values(item).some((value) => {
                if (value && typeof value === 'string') {
                    return value.toLowerCase().includes(searchTerm.toLowerCase());
                }
                if (value && typeof value === 'number') {
                    return value.toString().includes(searchTerm);
                }
                return false;
            });
        });
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchTerm, visitorData]);

    const [isExpanded, setIsExpanded] = useState(true);
    const toggleExpandCollapse = () => {
        setIsExpanded(!isExpanded);
    };

    const handleChange = async (selectedId) => {
        const selected = areas.find((area) => area.id === selectedId);
        setSelectedArea(selected);

        try {
            // ✅ Always call API, even for 0 ("All Areas")
            const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedId}`);
            setVisitorData(response.data.details);
        } catch (error) {
            console.error("Failed to fetch visitor data:", error);
            setVisitorData([]);
        }
    };
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('asc');
    // Calculate the total number of pages
    const sortData = (data, column, direction) => {
        const sortedData = [...data].sort((a, b) => {
            if (direction === 'asc') {
                return a[column] > b[column] ? 1 : -1;
            } else {
                return a[column] < b[column] ? 1 : -1;
            }
        });
        return sortedData;
    };

    const handleSort = (column) => {
        const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
        setSortColumn(column);
        setSortDirection(direction);
        const sortedData = sortData(filteredData, column, direction);
        setVisitorData(sortedData);
    };
    const [isQRPanelOpen, setIsQRPanelOpen] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [qrMode, setQrMode] = useState('');
    const [qrAction, setQrAction] = useState('');
    const [qrumber, setQrumber] = useState('');

    const toggleQRPanel = () => {
        setIsQRPanelOpen((prev) => !prev);
    };

    const handleQRClick = (type) => {
        setQrumber('');
        let mode = '';
        let action = '';

        switch (type) {
            case 'individual-checkin':
                mode = 'Individual';
                action = 'Check-In';
                break;
            case 'individual-checkout':
                mode = 'Individual';
                action = 'Check-Out';
                break;
            case 'group-checkin':
                mode = 'Group';
                action = 'Check-In';
                break;
            case 'group-checkout':
                mode = 'Group';
                action = 'Check-Out';
                break;
            default:
                return;
        }

        setQrMode(mode);
        setQrAction(action);
        setIsPopupOpen(true);
        setIsQRPanelOpen(false);
    };

    // useEffect(() => {
    //     if (isPopupOpen && qrMode && qrAction) {
    //         console.log("Popup is now open with values:");
    //         console.log("QRmode:", qrMode);
    //         console.log("QRaction:", qrAction);

    //         //  You can perform any logic here after popup opens
    //     }
    // }, [isPopupOpen, qrMode, qrAction]);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [pendingRequestData, setPendingRequestData] = useState(null);


    const buildRequestData = (decodedId) => ({
        checkedin: 0,
        inPremises: 0,
        checkedout: 0,
        crossed: 0,
        expectedCount: 0,
        udCount: 0,
        source: qrMode,
        visitorName: "string",
        checkInId: decodedId,
        visitorTypeDesc: "string",
        checkInType: "string",
        hostName: "string",
        gate: "string",
        checkInDateTime: null,
        passReturnedDateTime: null,
        serviceProviderAccess: "string",
        visitorMobile: "string",
        appointmentId: "string",
        photo: "",
        host: "string",
        location: "string",
        purpose: "string",
        recurring: "string",
        status: "string",
        repeatVisit: true,
        recurEvery: 0,
        recurrancePattern: 0,
        selectedRecurrence: "string",
        nationality: "string",
        meetingTo: null,
        areaCheckInDateTime: null,
        areaCheckOutDateTime: null,
        area: selectedArea?.name || "",
        override: false,  // initially false
        save: false,
        ndaDocument: "",
    });
    const [confirmationPopupQR, setConfirmationPopupQR] = useState({
        show: false,
        visitor: null,
        pendingRequestData: null
    });
    const [confirmationPopupQRO, setConfirmationPopupQRO] = useState({
        show: false,
        visitor: null,
        pendingRequestData: null
    });

    const handleNextButtonQRClick = async () => {
        if (qrumber === '') {
            toast.error("Please enter the QR code");
            return;
        }

        const decryptResponse = await axios.get(`/VisitorDetails/DecryptQR?qrCode=${qrumber}`);
        const decryptedData = decryptResponse.data;
        //console.log("QR", decryptedData);
        if (!decryptResponse.data) {
            toast.error("Invalid QR code. Please try again.");
            return;
        }

        const { appointmentType, id, passType } = decryptedData;
        // console.log("Decrypted ID:", id);
        // console.log("Decrypted appointmentType:", appointmentType);
        // console.log("Decrypted passType:", passType);

        if (passType !== "CheckIn") {
            toast.error("Please scan a valid QR code.");
            return;
        }

        const requestData = buildRequestData(`${id}`);
        try {
            if (qrAction === 'Check-In') {
                const response = await axios.post('Dashboard/AreaCheckIn', requestData);

                if (response.data?.statusCode === 0) {
                    // toast.success(response.data?.message);
                    console.log("Qr Code Response", response)
                    setQrumber('');
                    const requestWithOverride = { ...requestData, override: true };

                    setPendingRequestData(requestWithOverride);
                    setConfirmationPopupQR({
                        show: true,
                        visitor: {
                            visitorName: response.data.visitorName,
                            photo: response.data.visitorPhoto,
                            area: response.data.area,
                            isGroupMember: response.data.isGroupMember

                        },
                        pendingRequestData: requestWithOverride // ✅ use the same object
                    });
                    // console.log("Check-In Response:", response.data);
                    // setSelectedVisitor(null); // if used
                    // setIsPopupOpen(false); // ✅ close popup
                    // console.log("Check-In Response:", response.data);
                } else if (response.data?.statusCode === 1) {
                    toast.error(response.data?.message)
                    setQrumber('');
                    setSelectedVisitor(null); // if used
                    setIsPopupOpen(false); // ✅ close popup

                } else if (response.data?.statusCode === 2) {
                    toast.error(response.data?.message)
                    setQrumber('');
                    setSelectedVisitor(null); // if used
                    setIsPopupOpen(false); // ✅ close popup

                } else if (response.data?.statusCode === 3) {
                    // Not authorized — ask for override
                    const requestWithOverride = { ...requestData, override: true };

                    setPendingRequestData(requestWithOverride);
                    setConfirmationPopupQRO({
                        show: true,
                        visitor: {
                            visitorName: response.data.visitorName,
                            photo: response.data.visitorPhoto,
                            area: response.data.area,
                            isGroupMember: response.data.isGroupMember
                        },
                        pendingRequestData: requestWithOverride // ✅ use the same object
                    });
                    // setShowConfirmation(true);
                }

            } else if (qrAction === 'Check-Out') {
                const response = await axios.put('Dashboard/AreaCheckOut', requestData);
                if (response.data == "Visitor is not checked-in.") {
                    toast.error("Visitor is not checked-in.");
                    setQrumber('');
                    setIsPopupOpen(false); // ✅ close popup
                    return
                }
                toast.success("Check-Out successful");
                setQrumber('');
                setIsPopupOpen(false); // ✅ close popup
                //  console.log("Check-Out Response:", response.data);

            } else {
                toast.error("Invalid QR Action");
            }
        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
        const fetchAreasList = async () => {
            const id = 0;
            try {
                const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                setVisitorData(response.data.details);
            } catch (error) {
                console.error("Failed to fetch visitor data:", error);
                setVisitorData([]);
            }
        };
        fetchAreasList()
    };

    const confirmCheckInOverride = async () => {
        try {
            const response = await axios.post('Dashboard/AreaCheckIn', pendingRequestData);
            toast.success("Visitor checked into area successfully");
            setShowConfirmation(false);
            setPendingRequestData(null);
            setQrumber('');
            setIsPopupOpen(false); // ✅ close popup
        } catch (err) {
            console.error("Override Error:", err);
            toast.error("Override failed");
        }
        const fetchAreasList = async () => {
            const id = 0;
            try {
                const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                setVisitorData(response.data.details);
            } catch (error) {
                console.error("Failed to fetch visitor data:", error);
                setVisitorData([]);
            }
        };
        fetchAreasList()
    };


    function decodeCheckInId(qrcode) {
        // Mapping encoded byte pairs back to digits
        const reverseMapping = {
            "515253": "1",
            "303030": "3",
            "505050": "5",
            "202020": "2",
            "868484": "4",
            "606060": "6",
            "707070": "7",
            "808080": "8",
            "909090": "9",
            "000000": "0"
        };

        let checkInId = '';

        // Loop through the qrcode string in steps of 6 characters (each code is 6 characters long)
        for (let i = 0; i < qrcode.length; i += 6) {
            const segment = qrcode.substring(i, i + 6); // Extract each 6-character segment
            // Check if the segment exists in the reverse mapping
            if (reverseMapping[segment]) {
                checkInId += reverseMapping[segment]; // Map the segment back to the corresponding digit
            } else {
                console.error(`Error: Segment ${segment} not found in reverse mapping`);
                return ''; // Return an empty string if an invalid segment is encountered
            }
        }

        return checkInId; // Return the decoded check-in ID
    }

    const [searchTermD, setSearchTermD] = useState("");
    const [showOptions, setShowOptions] = useState(false);

    useEffect(() => {
        const allAreas = areas.find((a) => a.id === 0);
        if (allAreas) {
            setSelectedArea(allAreas);
            setSearchTermD(getDisplayName(allAreas));
            handleChange(0); // Call API for all areas on load
        }
    }, [areas]);
    const getDisplayName = (area) =>
        area?.id === 0 ? area.name : `${area.location} - ${area.name}`;

    const filteredAreas =
        selectedArea?.id === 0 && searchTermD === getDisplayName(selectedArea)
            ? areas // if "All Areas" selected & untouched → show full list
            : areas.filter((area) =>
                getDisplayName(area).toLowerCase().includes(searchTermD.toLowerCase())
            );





    return (
        <Container>
            <Header>
                <Heading>Area Check-In</Heading>
                <TopBar>
                    <DropdownWrapper>
                        <InputWrapper>
                            <SearchInputN
                                type="text"
                                placeholder="Search area..."
                                value={searchTermD}
                                onChange={(e) => setSearchTermD(e.target.value)}
                                onFocus={() => setShowOptions(true)}
                                onBlur={() => setTimeout(() => setShowOptions(false), 200)}
                            />
                            {searchTermD && (
                                <ClearButton
                                    type="button"
                                    onClick={() => {
                                        const allAreas = areas.find((a) => a.id === 0);
                                        if (allAreas) {
                                            setSelectedArea(allAreas);
                                            setSearchTermD(getDisplayName(allAreas)); // show "All Areas"
                                            handleChange(0); // ✅ API with id=0
                                        }
                                        setShowOptions(false);
                                    }}
                                >
                                    <AiOutlineClose size={16} />
                                </ClearButton>
                            )}
                        </InputWrapper>

                        {showOptions && (
                            <OptionsList>
                                {filteredAreas.map((area) => (
                                    <OptionItem
                                        key={area.id}
                                        onMouseDown={() => {
                                            handleChange(area.id);
                                            setSearchTermD(getDisplayName(area)); // show chosen area
                                            setShowOptions(false);
                                        }}
                                    >
                                        {getDisplayName(area)}
                                    </OptionItem>
                                ))}
                            </OptionsList>
                        )}
                    </DropdownWrapper>


                    <DropdownContainerQR>
                        <QRIcon
                            onClick={selectedArea?.id !== 0 ? toggleQRPanel : undefined}
                            title="QR Code Options"
                            disabled={selectedArea?.id === 0}
                            $disabled={selectedArea?.id === 0}
                        >
                            <MdQrCode size={25} />
                        </QRIcon>
                        {isQRPanelOpen && (
                            <QRPanel>
                                <QRItem onClick={() => handleQRClick('individual-checkin')}>
                                    <FiLogIn size={18} /> Individual QR Check-In
                                </QRItem>
                                <QRItem onClick={() => handleQRClick('individual-checkout')}>
                                    <FiLogOut size={18} /> Individual QR Check-Out
                                </QRItem>
                                <QRItem onClick={() => handleQRClick('group-checkin')}>
                                    <FiUsers size={18} /> Group QR Check-In
                                </QRItem>
                                <QRItem onClick={() => handleQRClick('group-checkout')}>
                                    <FiUserCheck size={18} /> Group QR Check-Out
                                </QRItem>
                            </QRPanel>
                        )}
                    </DropdownContainerQR>
                    {isPopupOpen && (
                        <PopupCh>
                            <PopupText>Scan QR Code:</PopupText>
                            <InputField
                                type="text"
                                placeholder="Scan QR Code"
                                maxLength="31"
                                value={qrumber}
                                onChange={(e) => setQrumber(e.target.value.replace(/\s+/g, ''))}
                            />
                            <PopupButton onClick={() => setIsPopupOpen(false)} style={{ backgroundColor: 'red' }}>
                                Close
                            </PopupButton>
                            <PopupButton onClick={handleNextButtonQRClick} style={{ marginLeft: '10px' }}>
                                Next
                            </PopupButton>
                        </PopupCh>
                    )}
                    {showConfirmation && (
                        <div style={{
                            position: 'fixed',
                            top: '50%',
                            left: '55%',
                            transform: 'translate(-50%, -50%)',
                            background: '#fff',
                            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
                            borderRadius: '10px',
                            padding: '30px',
                            textAlign: 'center',
                            opacity: 1,
                            zIndex: 1000,
                            width: '400px',
                            height: '125px',
                        }}>
                            <p style={{ marginBottom: '20px', fontSize: '16px', fontWeight: 500 }}>
                                You are not authorized. Do you want to override check-in?
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <button
                                    onClick={confirmCheckInOverride}
                                    style={{
                                        backgroundColor: '#293495',
                                        color: '#fff',
                                        padding: '8px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    onClick={() => {
                                        setShowConfirmation(false);
                                        setPendingRequestData(null);
                                    }}
                                    style={{
                                        backgroundColor: 'red',
                                        color: '#fff',
                                        padding: '8px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    )}


                    <SearchBox>
                        <SearchIcon />
                        <SearchInput
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </SearchBox>
                    <DropdownContainerTwoo>
                        <ExportIcono onClick={togglePanelE} title="Export">
                            <FiDownload size={25} />
                        </ExportIcono>
                        {isPanelOpenE && (
                            <OptionsPanelo>
                                <OptionItemo onClick={() => handleExportOptionClick('excel')}>Excel</OptionItemo>
                                <OptionItemo onClick={() => handleExportOptionClick('pdf')}>PDF</OptionItemo>
                            </OptionsPanelo>
                        )}
                    </DropdownContainerTwoo>

                </TopBar>
            </Header>

            <TableContainer>
                {currentData.length === 0 ? (
                    <ZeroStateMessage>No visitors to display</ZeroStateMessage>
                ) : (
                    <StyledTable>
                        <thead>
                            <tr>
                                <TableHeader>Photo</TableHeader>
                                <TableHeader onClick={() => handleSort('appointmentId')}>Visit ID (Appt ID){sortColumn === 'appointmentId' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('source')}>Visit Type{sortColumn === 'source' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('visitorName')}>Visitor Name{sortColumn === 'visitorName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('visitorTypeDesc')}>Visitor Type{sortColumn === 'visitorTypeDesc' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('visitorMobile')}>Mobile{sortColumn === 'visitorMobile' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('nationality')}>Natioality{sortColumn === 'nationality' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('host')}>Host{sortColumn === 'host' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('location')}>Location{sortColumn === 'location' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('area')}>Area{sortColumn === 'area' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('areaCheckInDateTime')}>Check-In (Area){sortColumn === 'areaCheckInDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader onClick={() => handleSort('areaCheckOutDateTime')}>Check-Out (Area){sortColumn === 'areaCheckOutDateTime' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                                <TableHeader>Actions</TableHeader>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.map((visitor, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Circle>
                                            {visitor.photo ? (
                                                <img
                                                    src={`data:image/png;base64,${visitor.photo}`}
                                                    alt="Profile"
                                                    style={{ width: '100%', height: '100%', borderRadius: '50%' }}
                                                />
                                            ) : (
                                                <ProfileIcon><User size={15} /></ProfileIcon>
                                            )}
                                        </Circle>
                                    </TableCell>
                                    <TableCell>{visitor.appointmentId}</TableCell>
                                    <TableCell>{visitor.source}</TableCell>
                                    <TableCell>{visitor.visitorName}</TableCell>
                                    <TableCell>{visitor.visitorTypeDesc}</TableCell>
                                    <TableCell>{visitor.visitorMobile}</TableCell>
                                    <TableCell>{visitor.nationality}</TableCell>
                                    <TableCell>{visitor.host}</TableCell>
                                    <TableCell>{visitor.location}</TableCell>
                                    <TableCell>{visitor.area}</TableCell>
                                    <TableCell>
                                        {visitor.areaCheckInDateTime === "0001-01-01T00:00:00" || visitor.areaCheckInDateTime === null
                                            ? " "
                                            : new Intl.DateTimeFormat('en-CA', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            }).format(new Date(visitor.areaCheckInDateTime))
                                                .replace(',', ' :')}
                                    </TableCell>
                                    <TableCell>
                                        {visitor.areaCheckOutDateTime === "0001-01-01T00:00:00" || visitor.areaCheckOutDateTime === null
                                            ? " "
                                            : new Intl.DateTimeFormat('en-CA', {
                                                year: 'numeric',
                                                month: '2-digit',
                                                day: '2-digit',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false
                                            }).format(new Date(visitor.areaCheckOutDateTime))
                                                .replace(',', ' :')}
                                    </TableCell>
                                    <TableCell>
                                        <IconWrapper onClick={() => {
                                            if (!selectedArea || selectedArea.id === 0) {
                                                toast.error("Please select an area before proceeding to check-in.");
                                                return;
                                            }
                                            setModalType('checkin');
                                            setSelectedVisitor(visitor);
                                            setShowModal(true);
                                        }}
                                            title="Check-In">
                                            <LogIn size={16} />
                                        </IconWrapper>
                                        <IconWrapper onClick={() => {
                                            if (!selectedArea || selectedArea.id === 0) {
                                                toast.error("Please select an area before proceeding to check-out.");
                                                return;
                                            }
                                            setModalType('checkout');
                                            setSelectedVisitor(visitor);
                                            setShowModal(true);
                                        }} title="Check-Out">
                                            <LogOut size={16} />
                                        </IconWrapper>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </tbody>
                    </StyledTable>
                )}
            </TableContainer>

            <PaginationContainer>
                <PaginationButton onClick={() => setCurrentPage(p => p - 1)} disabled={currentPage === 1}>
                    Previous
                </PaginationButton>
                <DropdownSelect value={currentPage} onChange={(e) => setCurrentPage(Number(e.target.value))}>
                    {Array.from({ length: totalPages }, (_, i) => (
                        <option key={i + 1} value={i + 1}>Page {i + 1}</option>
                    ))}
                </DropdownSelect>
                <PaginationButton onClick={() => setCurrentPage(p => p + 1)} disabled={currentPage === totalPages}>
                    Next
                </PaginationButton>
            </PaginationContainer>

            {showModal && (
                <>
                    <ModalOverlay />
                    <ModalContent>
                        <h3>Confirm {modalType === 'checkin' ? 'Check-In' : 'Check-Out'}</h3>
                        <FormGroup>
                            <Label>Mobile Number<Asterisk>*</Asterisk></Label>
                            <InputField
                                type="number"
                                placeholder="Enter Mobile Number"
                                value={enteredMobile}
                                onChange={(e) => setEnteredMobile(e.target.value)}
                            />
                        </FormGroup>


                        <ModalActions>
                            <ModalButton className="cancel" onClick={() => {
                                setShowModal(false);
                                setEnteredMobile('');
                            }}>Cancel</ModalButton>
                            <ModalButton className="ok" onClick={handleModalConfirm}>OK</ModalButton>
                        </ModalActions>
                    </ModalContent>
                </>
            )}
            {confirmationPopup?.show && confirmationPopup?.visitor && (
                <PopupOverlay>
                    <PopupContent>
                        <PopupTitle>Confirm Check-In</PopupTitle>
                        {confirmationPopup?.visitor.photo && (
                            <PopupImage
                                src={`data:image/png;base64,${confirmationPopup.visitor.photo}`}
                                alt="Visitor"
                            />)}
                        <PopupRow>
                            <Label>Visitor Name:</Label>
                            <Value>{confirmationPopup.visitor.visitorName}</Value>
                        </PopupRow>

                        <PopupRow>
                            <Label>Area:</Label>
                            <Value>{confirmationPopup.visitor.area}</Value>
                        </PopupRow>
                        <FormGroup>
                            {/* <Asterisk>*</Asterisk> */}
                            <Label>NDA Document {confirmationPopup.visitor?.isGroupMember ? "" : ""}  </Label>
                            <FileUploadContainer>
                                <CustomFileButton
                                    onClick={() =>
                                        document.getElementById("transportVendorFileInput").click()
                                    }
                                >
                                    Choose File
                                </CustomFileButton>

                                <FileNameInput
                                    type="text"
                                    value={transportVendorFileName || ""}
                                    placeholder="No file chosen"
                                    readOnly
                                />

                                <HiddenFileInput
                                    id="transportVendorFileInput"
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    onChange={async (e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setTransportVendorFileName(file.name);

                                            try {
                                                const base64String = await fileToBase64(file);
                                                setTransportVendorFileBase64(base64String); // store base64 string
                                            } catch (err) {
                                                console.error("File conversion error:", err);
                                            }
                                        }
                                    }}
                                />
                            </FileUploadContainer>
                        </FormGroup>
                        <PopupButtons>
                            <PopupButtonNo
                                onClick={() =>
                                    setConfirmationPopup({ show: false, visitor: null, payload: null })
                                }
                            >
                                No
                            </PopupButtonNo>
                            <PopupButtonYes
                                onClick={async () => {
                                    try {
                                        const isGroupMember = confirmationPopup.visitor?.isGroupMember;
                                        const hasNdaFile = Boolean(transportVendorFileName);
                                        // && !hasNdaFile

                                        // if (!isGroupMember) {
                                        //     toast.error("NDA Document file is mandatory");
                                        //     return;
                                        // }

                                        const ndaDocument = transportVendorFileBase64;

                                        const payloadWithSave = { ...confirmationPopup.payload, save: true, ndaDocument: ndaDocument };
                                        const response = await axios.post('Dashboard/AreaCheckIn', payloadWithSave);
                                        if (response.data?.statusCode === 0) {
                                            toast.success(response.data?.message);
                                        } else {
                                            toast.error(response.data?.message);
                                        }
                                    } catch (error) {
                                        toast.error('Failed to complete check-in.');
                                    } finally {
                                        setTransportVendorFileBase64("")
                                        setTransportVendorFileName('')
                                    }
                                    const fetchAreasList = async () => {
                                        const id = 0;
                                        try {
                                            const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                                            setVisitorData(response.data.details);
                                        } catch (error) {
                                            console.error("Failed to fetch visitor data:", error);
                                            setVisitorData([]);
                                        }
                                    };
                                    fetchAreasList()
                                    setConfirmationPopup({ show: false, visitor: null, payload: null });
                                }}
                            >
                                Yes
                            </PopupButtonYes>
                        </PopupButtons>
                    </PopupContent>
                </PopupOverlay>
            )}

            {confirmationPopupQR?.show && confirmationPopupQR?.visitor && (
                <PopupOverlay>
                    <PopupContent>
                        <PopupTitle>Confirm Check-In</PopupTitle>
                        {confirmationPopupQR?.visitor.photo && (
                            <PopupImage
                                src={`data:image/png;base64,${confirmationPopupQR.visitor.photo}`}
                                alt="Visitor"
                            />)}
                        <PopupRow>
                            <Label>Visitor Name:</Label>
                            <Value>{confirmationPopupQR.visitor.visitorName}</Value>
                        </PopupRow>
                        <PopupRow>
                            <Label>Area:</Label>
                            <Value>{confirmationPopupQR.visitor.area}</Value>
                        </PopupRow>
                        <FormGroup>
                            {/* <Asterisk>*</Asterisk> */}
                            <Label>NDA Document  {confirmationPopupQR.visitor?.isGroupMember ? "" : ""}</Label>
                            <FileUploadContainer>
                                <CustomFileButton
                                    onClick={() =>
                                        document.getElementById("transportVendorFileInput").click()
                                    }
                                >
                                    Choose File
                                </CustomFileButton>

                                <FileNameInput
                                    type="text"
                                    value={transportVendorFileName || ""}
                                    placeholder="No file chosen"
                                    readOnly
                                />

                                <HiddenFileInput
                                    id="transportVendorFileInput"
                                    type="file"
                                    accept=".pdf,.doc,.docx"
                                    onChange={async (e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setTransportVendorFileName(file.name);

                                            try {
                                                const base64String = await fileToBase64(file);
                                                setTransportVendorFileBase64(base64String); // store base64 string
                                            } catch (err) {
                                                console.error("File conversion error:", err);
                                            }
                                        }
                                    }}
                                />
                            </FileUploadContainer>
                        </FormGroup>
                        <PopupButtons>
                            <PopupButtonNo
                                onClick={() => {
                                    setConfirmationPopupQR({ show: false, visitor: null, pendingRequestData: null })
                                    setTransportVendorFileBase64("")
                                    setTransportVendorFileName('')
                                }
                                }
                            >
                                No
                            </PopupButtonNo>
                            <PopupButtonYes
                                onClick={async () => {
                                    try {
                                        const isGroupMember = confirmationPopupQR.visitor?.isGroupMember;
                                        const hasNdaFile = Boolean(transportVendorFileName);
                                        //  && !hasNdaFile

                                        // if (!isGroupMember) {
                                        //     toast.error("NDA Document file is mandatory");
                                        //     return;
                                        // }
                                        const ndaDocument = transportVendorFileBase64;

                                        const payloadWithSave = { ...confirmationPopupQR.pendingRequestData, save: true, ndaDocument: ndaDocument };
                                        const response = await axios.post('Dashboard/AreaCheckIn', payloadWithSave);
                                        if (response.data?.statusCode === 0) {
                                            toast.success(response.data?.message);
                                        } else {
                                            toast.error(response.data?.message);
                                        }
                                    } catch (error) {
                                        toast.error('Failed to complete check-in.');
                                    } finally {
                                        // Cleanup ALWAYS runs
                                        setTransportVendorFileBase64("");
                                        setTransportVendorFileName('');
                                    }

                                    setConfirmationPopupQR({ show: false, visitor: null, pendingRequestData: null });
                                    const fetchAreasList = async () => {
                                        const id = 0;
                                        try {
                                            const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                                            setVisitorData(response.data.details);
                                        } catch (error) {
                                            console.error("Failed to fetch visitor data:", error);
                                            setVisitorData([]);
                                        }
                                    };
                                    fetchAreasList()
                                    setIsPopupOpen(false); // ✅ close popup
                                }}
                            >
                                Yes
                            </PopupButtonYes>
                        </PopupButtons>
                    </PopupContent>
                </PopupOverlay>
            )
            }

            {
                confirmationPopupQRO?.show && confirmationPopupQRO?.visitor && (
                    <PopupOverlay>
                        <PopupContent>
                            <PopupTitle>Confirm Check-In</PopupTitle>
                            {confirmationPopupQRO?.visitor.photo && (
                                <PopupImage
                                    src={`data:image/png;base64,${confirmationPopupQRO.visitor.photo}`}
                                    alt="Visitor"
                                />)}
                            <PopupRow>
                                <Label>Visitor Name:</Label>
                                <Value>{confirmationPopupQRO.visitor.visitorName}</Value>
                            </PopupRow>

                            <PopupRow>
                                <Label>Area:</Label>
                                <Value>{confirmationPopupQRO.visitor.area}</Value>
                            </PopupRow>

                            <FormGroup>
                                {/* <Asterisk>*</Asterisk> */}
                                <Label>NDA Document  {confirmationPopupQRO.visitor?.isGroupMember ? "" : ""}</Label>
                                <FileUploadContainer>
                                    <CustomFileButton
                                        onClick={() =>
                                            document.getElementById("transportVendorFileInput").click()
                                        }
                                    >
                                        Choose File
                                    </CustomFileButton>

                                    <FileNameInput
                                        type="text"
                                        value={transportVendorFileName || ""}
                                        placeholder="No file chosen"
                                        readOnly
                                    />

                                    <HiddenFileInput
                                        id="transportVendorFileInput"
                                        type="file"
                                        accept=".pdf,.doc,.docx"
                                        onChange={async (e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setTransportVendorFileName(file.name);

                                                try {
                                                    const base64String = await fileToBase64(file);
                                                    setTransportVendorFileBase64(base64String); // store base64 string
                                                } catch (err) {
                                                    console.error("File conversion error:", err);
                                                }
                                            }
                                        }}
                                    />
                                </FileUploadContainer>
                            </FormGroup>
                            <p style={{ color: 'red', fontWeight: 'bold', marginBottom: '8px' }}>
                                ⚠️ Area does not match. Override required.
                            </p>

                            <PopupButtons>
                                <PopupButtonNo
                                    onClick={() => {
                                        setConfirmationPopupQRO({ show: false, visitor: null, payload: null })
                                        setTransportVendorFileBase64("");
                                        setTransportVendorFileName('');
                                    }}
                                >
                                    Cancel
                                </PopupButtonNo>
                                <PopupButtonYes
                                    onClick={async () => {
                                        try {
                                            const isGroupMember = confirmationPopupQRO.visitor?.isGroupMember;
                                            const hasNdaFile = Boolean(transportVendorFileName);
                                            // && !hasNdaFile

                                            // if (!isGroupMember) {
                                            //     toast.error("NDA Document file is mandatory");
                                            //     return;
                                            // }
                                            const ndaDocument = transportVendorFileBase64;


                                            const payloadWithSave = { ...confirmationPopupQRO.pendingRequestData, save: true, ndaDocument: ndaDocument };
                                            const response = await axios.post('Dashboard/AreaCheckIn', payloadWithSave);
                                            if (response.data?.statusCode === 0) {
                                                toast.success(response.data?.message);
                                            } else {
                                                toast.error(response.data?.message);
                                            }
                                        } catch (error) {
                                            toast.error('Failed to complete check-in.');
                                        } finally {
                                            // Cleanup ALWAYS runs
                                            setTransportVendorFileBase64("");
                                            setTransportVendorFileName('');
                                        }
                                        setConfirmationPopupQRO({ show: false, visitor: null, pendingRequestData: null });
                                        const fetchAreasList = async () => {
                                            const id = 0;
                                            try {
                                                const response = await axios.get(`Dashboard/GetAreaCheckInByArea/${selectedArea?.id}`);
                                                setVisitorData(response.data.details);
                                            } catch (error) {
                                                console.error("Failed to fetch visitor data:", error);
                                                setVisitorData([]);
                                            }
                                        };
                                        fetchAreasList()
                                        setIsPopupOpen(false); // ✅ close popup
                                    }}
                                >
                                    Override
                                </PopupButtonYes>
                            </PopupButtons>
                        </PopupContent>
                    </PopupOverlay>
                )
            }


            <ToastContainer />

        </Container >
    );
};

export default AreaCheckIn;